<template>

  <div class="padded">

    <data-table
      table-ref="site-contractors-table"
      title="Contractors Statement"
      :url="'/contractor/site/' + siteId"
      hide-org-badge
      sort-field="started"
      :fields="fields"
      :add-action="action"
      :add-props="addPropsData"
      detail-component="site-contractors-detail-row">

      <template slot="admin-action" slot-scope="props">
          <el-button v-if="isSuper() || isManager('finance')"
            class="hidden-md-and-down"
            type="danger" size="mini" icon="fa fa-trash-alt"
            @click="deleteRow(props.rowData)" circle>
          </el-button>
      </template>

    </data-table>

  </div>

</template>


<script>

import Vue from 'vue'
import VueEvents from 'vue-events'

Vue.use(VueEvents)

import SiteContractorAction from '@/components/actions/SiteContractorAction'
import SiteContractorDetails from '@/components/sites/finance/contractors/SiteContractorsDetails'

Vue.component('site-contractors-detail-row', SiteContractorDetails)

import {settings} from '@/components/Data'

import SiteMixins from '@/mixins/SiteMixins'

export default {

  mixins: [SiteMixins],

  props: {

    siteId: {
      type: Number,
      required: true
    },

  },



  methods: {

    deleted () {
      this.$events.fire('site-contractors-table-refresh-table')
    },

    deleteRow (row) {
      if (row) {
        this.deleteItem(this, row.id, '/contractors', 'Contractor ' + row.contractor.shortName + (row.type ? ' Type ' + row.type : (row.summary ? 'Summary: ' + row.summary : 'Inv. No: ' + row.invoiceNo)), this.deleted)
      }
    },

  },

  data () {
    return {
      action: SiteContractorAction,

      addPropsData: {
        siteId: this.siteId,
        editMode: true,
        adding: true,
        tableRef: 'site-contractors-table'
      },

      taxLabel: settings.taxName,

      fields: [
        {
          name: 'contractor.shortName',
          title: 'Short Name',
        },
        {
          name: 'type',
          title: 'Type',
          sortField: 'type'
        },
        {
          name: 'summary',
          title: 'Summary',
          sortField: 'summary',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'started',
          title: 'Started',
          callback: this.formatDateTime,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'ended',
          title: 'Ended',
          callback: this.formatDateTime,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'amount',
          title: 'Amount',
          callback: this.formatNumber,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'tax',
          title: this.taxLabel,
          callback: this.formatNumber,
          visible: this.showTax(),
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'total',
          title: 'TOTAL',
          callback: this.formatNumber,
          visible: this.showTax()
        },
        {
          name: '__slot:admin-action',
          visible: (this.isSuper() || this.isManager('finance'))
        }
      ]
    }
  }
}

</script>
